import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIModule } from '@c4/ui';

import { ProgrammingCommonModule } from '../../common/common.module';
import { QuickstartSystemRemotesModule } from './../quickstart-system-remotes/quickstart-system-remotes.module';
import { QuickstartLightsModule } from './../quickstart-lights/quickstart-lights.module';
import { QuickstartKeypadsModule } from './../quickstart-keypads/quickstart-keypads.module';

import { SelectTypeComponent } from './select-type/select-type.component';
import { ButtonsComponent } from './buttons.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    UIModule,
    ProgrammingCommonModule,
    QuickstartKeypadsModule,
    QuickstartLightsModule,
    QuickstartSystemRemotesModule,
  ],
  declarations: [
    SelectTypeComponent,
    ButtonsComponent
  ],
})
export class QuickstartButtonsModule { }



// WEBPACK FOOTER //
// ./~/@c4/programming/src/app/quickstarts/quickstart-buttons/buttons.module.ts